function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M4.70 17.21L4.70 17.21Q3.41 17.21 2.34 16.55Q1.27 15.89 0.64 14.80Q0 13.70 0 12.38L0 12.38L0 11.28Q0 11.16 0.12 11.16L0.12 11.16L2.81 11.16Q2.90 11.16 2.90 11.28L2.90 11.28L2.90 12.38Q2.90 13.18 3.43 13.74Q3.96 14.30 4.70 14.30L4.70 14.30Q5.45 14.30 5.98 13.73Q6.50 13.15 6.50 12.38L6.50 12.38Q6.50 11.50 5.35 10.85L5.35 10.85Q4.97 10.63 4.15 10.18Q3.34 9.72 2.62 9.31L2.62 9.31Q1.30 8.54 0.66 7.38Q0.02 6.22 0.02 4.75L0.02 4.75Q0.02 3.41 0.67 2.34Q1.32 1.27 2.39 0.65Q3.46 0.02 4.70 0.02L4.70 0.02Q5.98 0.02 7.04 0.66Q8.11 1.30 8.75 2.36Q9.38 3.43 9.38 4.75L9.38 4.75L9.38 6.72Q9.38 6.82 9.29 6.82L9.29 6.82L6.60 6.82Q6.50 6.82 6.50 6.72L6.50 6.72L6.48 4.75Q6.48 3.91 5.95 3.38Q5.42 2.86 4.70 2.86L4.70 2.86Q3.96 2.86 3.43 3.42Q2.90 3.98 2.90 4.75L2.90 4.75Q2.90 5.54 3.24 6.07Q3.58 6.60 4.46 7.08L4.46 7.08Q4.58 7.15 4.93 7.33Q5.28 7.51 5.69 7.74Q6.10 7.97 6.42 8.14Q6.74 8.30 6.82 8.35L6.82 8.35Q8.02 9.02 8.71 10.00Q9.41 10.97 9.41 12.38L9.41 12.38Q9.41 13.75 8.77 14.84Q8.14 15.94 7.07 16.57Q6 17.21 4.70 17.21ZM13.92 16.97L11.21 16.97Q11.09 16.97 11.09 16.85L11.09 16.85L11.11 0.36Q11.11 0.26 11.21 0.26L11.21 0.26L13.90 0.26Q13.99 0.26 13.99 0.36L13.99 0.36L14.02 16.85Q14.02 16.97 13.92 16.97L13.92 16.97ZM18.74 16.97L16.34 16.97Q16.15 16.97 16.15 16.80L16.15 16.80L16.13 0.46Q16.13 0.26 16.32 0.26L16.32 0.26L18.48 0.26L22.54 9.72L22.42 0.46Q22.42 0.26 22.63 0.26L22.63 0.26L25.01 0.26Q25.15 0.26 25.15 0.46L25.15 0.46L25.18 16.82Q25.18 16.97 25.06 16.97L25.06 16.97L22.94 16.97L18.79 8.14L18.96 16.78Q18.96 16.97 18.74 16.97L18.74 16.97ZM35.88 16.97L26.93 16.97Q26.81 16.97 26.81 16.85L26.81 16.85L26.81 14.14Q26.81 14.09 26.86 14.04L26.86 14.04L32.78 5.90Q32.95 5.69 33.06 5.34Q33.17 4.99 33.17 4.73L33.17 4.73Q33.17 4.03 32.66 3.44Q32.16 2.86 31.39 2.86L31.39 2.86Q30.65 2.86 30.13 3.42Q29.62 3.98 29.62 4.85L29.62 4.85L29.62 6.02Q29.62 6.14 29.50 6.14L29.50 6.14L26.81 6.14Q26.71 6.14 26.71 6.02L26.71 6.02L26.71 4.85Q26.71 3.50 27.37 2.40Q28.03 1.30 29.10 0.65Q30.17 0 31.39 0L31.39 0Q32.69 0 33.74 0.66Q34.80 1.32 35.44 2.40Q36.07 3.48 36.07 4.73L36.07 4.73Q36.07 5.52 35.80 6.34Q35.52 7.15 35.04 7.78L35.04 7.78L30.48 14.04L35.88 14.04Q35.98 14.04 35.98 14.14L35.98 14.14L35.98 16.85Q35.98 16.97 35.88 16.97L35.88 16.97ZM40.61 16.97L37.90 16.97Q37.80 16.97 37.80 16.87L37.80 16.87L37.80 14.16Q37.80 14.06 37.90 14.06L37.90 14.06L40.61 14.06Q40.70 14.06 40.70 14.16L40.70 14.16L40.70 16.87Q40.70 16.97 40.61 16.97L40.61 16.97ZM45.50 16.97L42.79 16.97Q42.67 16.97 42.67 16.85L42.67 16.85L42.70 0.36Q42.70 0.26 42.79 0.26L42.79 0.26L45.48 0.26Q45.58 0.26 45.58 0.36L45.58 0.36L45.60 16.85Q45.60 16.97 45.50 16.97L45.50 16.97ZM52.15 17.21L52.15 17.21Q50.86 17.21 49.79 16.55Q48.72 15.89 48.07 14.80Q47.42 13.70 47.42 12.38L47.42 12.38L47.45 4.78Q47.45 3.46 48.08 2.38Q48.72 1.30 49.80 0.65Q50.88 0 52.15 0L52.15 0Q53.45 0 54.50 0.65Q55.56 1.30 56.20 2.38Q56.83 3.46 56.83 4.78L56.83 4.78L56.86 12.38Q56.86 13.70 56.22 14.80Q55.58 15.89 54.52 16.55Q53.45 17.21 52.15 17.21ZM52.15 14.30L52.15 14.30Q52.87 14.30 53.41 13.72Q53.95 13.13 53.95 12.38L53.95 12.38L53.93 4.78Q53.93 3.98 53.42 3.43Q52.92 2.88 52.15 2.88L52.15 2.88Q51.41 2.88 50.88 3.42Q50.35 3.96 50.35 4.78L50.35 4.78L50.35 12.38Q50.35 13.18 50.88 13.74Q51.41 14.30 52.15 14.30Z",
  transform: "translate(0, 5.897)"
});

var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 65.856,
  y1: "2%",
  x2: 65.856,
  y2: "98%",
  stroke: "currentColor",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "url(#grad1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,23.787L8.102,16L16,8.213L23.898,16L16,23.787z M9.525,16L16,22.383L22.475,16L16,9.617L9.525,16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.915,31.778l-15.92-15.694l16.09-15.862l15.92,15.694L15.915,31.778z M1.419,16.084l14.496,14.29l14.666-14.458 L16.085,1.626L1.419,16.084z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 15.5,
  y: 0.924,
  width: 1,
  height: 30.152
}));

function SvgLogoOldOld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103.9 29",
    width: 103.9,
    height: 29,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff0059",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "44%",
    style: {
      stopColor: "rgba(86, 58, 217, 1)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "85%",
    style: {
      stopColor: "rgba(30, 110, 232, 1)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(48, 131, 224, 1)",
      stopOpacity: 1
    }
  }))), _ref3, /*#__PURE__*/React.createElement("g", {
    fill: "url(#grad1)",
    color: "red",
    transform: "translate(74.856 0) scale(0.90625)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "url(#grad1)",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref4)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOldOld);
export default __webpack_public_path__ + "static/media/logo_old_old.d74261fd.svg";
export { ForwardRef as ReactComponent };